import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { ApplicationUser } from './ApplicationUser';

export class UserAccount extends ApplicationUser {
    _originalTypeClassName = "zERP.BO.UserAccount";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
UserAccount.translate = translateService;
}
super();
this.IncomeReceipt = [];
this.SSOUser = false;
this._key = this.UserName = ""; 
}

static translate: TranslateService;
_key: any;
SSOUser:any;
Employee:any;
SelectedYear:any;
SelectedEntity:any;
IncomeReceipt:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null && oldValue.UserAccount != null) { oldValue.UserAccount = null; }
if ($this.Employee.UserAccount !== $this) {
Domain.Employee.setUserAccount(value, $this);
}
}
}
static setSelectedYear = ($this, value) => {
var oldValue = $this.SelectedYear;
$this.SelectedYear = value;
if (value != null) {
}
}
static setSelectedEntity = ($this, value) => {
var oldValue = $this.SelectedEntity;
$this.SelectedEntity = value;
if (value != null) {
}
}
static setIncomeReceipt = ($this, items) => {
                if (items == null) items = [];
                if ($this.IncomeReceipt == null) $this.IncomeReceipt = [];

                const copyItems = Common.cloneObject(items);

                while ($this.IncomeReceipt.length > 0) {
                    Domain.UserAccount.removeIncomeReceipt($this, $this.IncomeReceipt[0]);
                }

                Domain.UserAccount.addManyIncomeReceipt($this, copyItems);
            }
static addManyIncomeReceipt = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.UserAccount.addIncomeReceipt($this, items[i]);
                }
            }
static addIncomeReceipt = ($this, item) => {
                if ($this.IncomeReceipt == null) $this.IncomeReceipt = [];
                if (item == null || $this.IncomeReceipt.indexOf(item) > -1) return;
                $this.IncomeReceipt.push(item);
if (item.CreatedBy != $this) {
Domain.IncomeReceipt.setCreatedBy(item, $this);
}
}
static addRangeIncomeReceipt = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.UserAccount.addIncomeReceipt($this, item));
            }
static removeIncomeReceipt = ($this, item) => {
                if ($this == null || $this.IncomeReceipt == null || $this.IncomeReceipt.indexOf(item) === -1) return;
                var _index = $this.IncomeReceipt.indexOf(item);
                $this.IncomeReceipt.splice(_index, 1);
item.CreatedBy = null;
}
static clearIncomeReceipt = ($this) => { $this.IncomeReceipt = null; }

static GetActive(): any{try {return Joove.Common.cast(window._context.currentUser, "Domain.UserAccount");}
catch (e) {return null;}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.UserName == null || $this.UserName == "";
            }


}